import { Box, Group, Button, Center, AspectRatio, Card, Flex, Select } from '@mantine/core';
import { IconCrop, IconFlipHorizontal, IconFlipVertical, IconRotate2, IconRotateClockwise2 } from '@tabler/icons-react';
import React, { useRef, useState } from 'react';
import { Cropper, CropperPreview } from 'react-advanced-cropper';
import 'react-advanced-cropper/dist/style.css'

export const CropEditor = (props) => {
    const cropperRef = useRef(null);
    const previewRef = useRef(null);
    const [aspectRatio, setAspectRatio] = useState('0');


    const [image, setImage] = useState(() => {

        if (props.src.startsWith('https://') && !props.src.startsWith('https://images.unsplash.com')) {
            return route('editor_tools.crop_preview', { image_url: props.src });
        }

        return props.src
    });

    const onCropClick = () => {
        if (cropperRef.current) {
            const cropper = cropperRef.current;
            const canvas = cropper.getCanvas();
            
            if (canvas) {
                props?.onCrop(canvas);
                setImage(canvas.toDataURL())

                const imageSize = cropper?.getImage();

                if (imageSize) {
                    cropper.setCoordinates({
                        width: imageSize?.width,
                        height: imageSize?.height,
                        left: 0,
                        top: 0,
                    });
                }
            }
        }
    };

    const handleAspectRatioChange = (value) => {
        setAspectRatio(value === "0" ? null : Number(value));
    };

    const onUpdate = (cropper) => {
        previewRef.current?.update(cropper);
    };

    return (
        <div style={{ display: 'flex', justifyContent: 'center', }}>
            <AspectRatio ratio={5 / 4} flex="0 0 100px">
                <Box pos="relative">
                    <Cropper
                        stencilProps={{
                            grid: true,
                            aspectRatio: aspectRatio,
                        }}
                        ref={cropperRef}
                        src={image}
                        style={{ height: "auto", width: "auto", minWidth: 500 }}
                        onUpdate={onUpdate}
                        crossOrigin="anonymous"
                        backgroundClassName='pattern-background'
                    />

                    {/* Navigation */}
                    <Card shadow="md" withBorder p="sm" mt="md" radius="md">
                        <Group justify="space-between">
                            <Flex justify="flex-start" align="flex-end" gap={4}>
                                <Select
                                    size="xs"
                                    w={100}
                                    radius="md"
                                    value={aspectRatio === null ? "0" : String(aspectRatio)}
                                    onChange={handleAspectRatioChange}
                                    label="Aspect Ratio"
                                    placeholder="aspect ratio"
                                    data={[
                                        { value: "0", label: "Free" },
                                        { value: "1.7778", label: "16:9" },
                                        { value: "1.3333", label: "4:3" },
                                        { value: "1", label: "1:1 (Square)" }
                                    ]}
                                />
                                <Button title="Rotate" size="xs" radius="sm" px="xs" variant="default" onClick={() => cropperRef.current.rotateImage(-90)}>
                                    <IconRotate2 size={18} />
                                </Button>

                                <Button title="Rotate" size="xs" radius="sm" px="xs" variant="default" onClick={() => cropperRef.current.rotateImage(90)}>
                                    <IconRotateClockwise2 size={18} />
                                </Button>

                                <Button title="Rotate" size="xs" radius="sm" px="xs" variant="default" onClick={() => cropperRef.current.flipImage(false, true)}>
                                    <IconFlipHorizontal size={18} />
                                </Button>

                                <Button title="Rotate" size="xs" radius="sm" px="xs" variant="default" onClick={() => cropperRef.current.flipImage(true, false)}>
                                    <IconFlipVertical size={18} />
                                </Button>

                            </Flex>

                            <Group justify="flex-end">
                                <Button color="smartico-blue" leftSection={<IconCrop />} onClick={onCropClick} radius="md">Crop</Button>
                            </Group>
                        </Group>
                    </Card>

                    <Box mt="md">

                    </Box>
                    {/* <div style={{ position: "absolute" }}>
                <CropperPreview
                    ref={previewRef}
                    className="preview"
                />
            </div> */}

                </Box>
            </AspectRatio>
        </div >
    )
}